export const ENV = process.env.REACT_APP_ENV || 'dev'


export const APP_URL = ENV === 'dev' ? 'http://localhost:3000/' : 'https://app.junus-ai.com/';
export const API_URL = ENV === 'dev' ? 'http://localhost:4000/' : 'https://backend.junus-ai.com/';
export const PUBLIC_API_URL = API_URL + 'public/'
export const SECURED_API_URL = API_URL + 'api/'
export const INFO_MAIL = 'info@junus.ai';

export const ENDPOINTS = {
    SIGNUP: PUBLIC_API_URL + 'register',
    SIGNIN: PUBLIC_API_URL + 'login',
    FORGOT_PASSWORD: PUBLIC_API_URL + 'forgotPassword',
    RESET_PASSWORD: PUBLIC_API_URL + 'resetPassword',
    GOOGLE_SIGNIN: PUBLIC_API_URL + 'google-oauth',
    GOOGLE_SIGNUP: PUBLIC_API_URL + 'google-oauth',
    GET_ALL_SKILLS: SECURED_API_URL + 'getAllSkills',
    MY_LEARNING: SECURED_API_URL + 'getMyLearning',
    GET_MY_LEARNING_SKILLS: SECURED_API_URL + 'getMyLearningSkills',
    GET_MY_COACH_PLAN: SECURED_API_URL + 'getMyCoachPlan',
    GET_CHALLENGE_OVERVIEW: SECURED_API_URL + 'getChallengeOverview',
    GENERATE_CHALLENGE: SECURED_API_URL + 'generateChallenge',
    SUBMIT_CHALLENGE: SECURED_API_URL + 'submitChallenge',
    CREATE_PERSONAL_COURSE: SECURED_API_URL + 'personal-courses',
    GET_PERSONAL_COURSES: SECURED_API_URL + 'personal-courses',
    GET_PERSONAL_COURSE: SECURED_API_URL + 'personal-courses/',
    UPDATE_PERSONAL_COURSE_PROGRESS: SECURED_API_URL + 'personal-courses/',
    SUBMIT_PERSONAL_COURSE_PRACTICE: SECURED_API_URL + 'personal-courses/',
    REGENERATE_PERSONAL_COURSE: SECURED_API_URL + 'personal-courses/',
    DELETE_PERSONAL_COURSE: SECURED_API_URL + 'personal-courses/',
    GET_MY_PROGRESS: SECURED_API_URL + 'getMySkillProgress/',
    GET_SKILL_DETAILS: SECURED_API_URL + 'getSkillDetails/',
    GET_SKILL_ASSESSMENT: SECURED_API_URL + 'getSkillAssessment/',
    SUBMIT_ASSESSMENT: SECURED_API_URL + 'submitAssessment',
    GET_SKILLS_FOR_H2HQUIZ: SECURED_API_URL + 'getSkillsForHeadToHeadQuiz',
    GET_TOP_SKILL_LEARNERS: SECURED_API_URL + 'getTopSkillLearners',
    GET_USER: SECURED_API_URL + 'getUser/',
    GET_DASHBOARD_STATS: SECURED_API_URL + 'getUserDashboardStats',
    GET_MOST_LEARNED_SKILLS: SECURED_API_URL + 'getMostLearnedSkills',
    CREATE_STRIPE_SESSION: SECURED_API_URL + 'createStripeSession',
    GET_PRICING_PLANS: SECURED_API_URL + 'getPricingPlans',
    VERIFY_PAYMENT: SECURED_API_URL + 'verifyPayment',
    DOWNLOAD_CERTIFICATE: SECURED_API_URL + 'downloadCertificate/',
    UPDATE_MY_LEARNING_LANGUAGE: SECURED_API_URL + 'updateMyLearningLanguage',
    CANCEL_MY_SUBSCRIPTION: SECURED_API_URL + 'cancelMySubsription',
}

export const NUMBER_OF_LESSONS = [
    1, 2, 3, 4, 5, 6, 7
]

export const USER_LEVELS = ["Beginner", "Intermediate", "Advanced"];

export const APP_DISPLAY_NAME = 'JUNUS.AI';
export const FEATURE_PERSONAL_COURSE = true;

export const AVAILABLE_LANGUAGES = [
    "English",
    "Spanish",
    "French",
    "German",
    "Italian",
    "Chinese",
    "Arabic",
    "Russian",
    "Japanese",
    "Hindi",
    "Albanian"
];

export const GOOGLE_CLIENT_ID = '1049790115887-qgdo3d12mjp8k6ced951ul8itnoojjn5.apps.googleusercontent.com';
export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || '1x00000000000000000000AA';


export const STRIPE_PUBLIC_KEY = ENV == 'dev' ? 'pk_test_51QfRRKGTC3oGVFg1KYJZ6HNCu12QIcaSdmuxrVQkidbFTfYBAc5NBYuAW6mhJM30aN5FWp4AoGK3cjofxF3qOsI400pz26t00c' : 'pk_live_51QfRRKGTC3oGVFg1P22AtM6aUPeK5BlIoCdChMmouaEB7M1NvBZ5tFkVqbPqoWHQWTRvipZYHDfOOMmUZZ4The4f00H8dl5SIl';
